import { IAircraftCompiled } from '@simplyfly/shared';
export const getAircraftCompiledModelTitle = (aircraftCompiled: IAircraftCompiled): string => {
  if (aircraftCompiled.modelTitle) {
    return aircraftCompiled.modelTitle;
  } else {
    return aircraftCompiled.model;
  }
};
